import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { cn } from 'utils/classNames';

type Spaces = 'double' | 'half' | 'single';

interface Props extends SitecoreBlockProps {
	fields: {
		space: Field<Spaces>;
	};
}

export default function Spacer(props: Props) {
	const { space } = props.fields;

	return (
		<div
			className={cn(
				space.value === 'half' && 'h-6',
				space.value === 'single' && 'h-10',
				space.value === 'double' && 'h-20',
			)}
		/>
	);
}
Spacer.displayName = 'Spacer';
